module.exports = __webpack_public_path__ + "static/media/user_white.8bbd202f.svg";